// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"19":"127a7839","157":"5f6fa2b2","446":"23fe1841","639":"1d79e98e","854":"458906c0","920":"1f1d284c","960":"27abff8d"}[chunkId] + ".css";
};